import { Row, Col, Card, CardBody } from "reactstrap";
import { Icons } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ThemifyCommonProp } from "../../../../Type/CommonComponant";

const ThemifyCommon = ({ iconType, title, parentCallback }: ThemifyCommonProp) => {
  const getItag = (tag: string) => parentCallback(tag);

  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={`${title} ${Icons}`} />
        <CardBody>
          <Row className="icon-lists">
            {iconType.map((icon, index: number) => {
              return (
                <Col sm="6" lg="4" key={index} onClick={(e) => getItag(icon)}>
                  <i className={`${icon}`}></i> {icon}
                </Col>
              );
            })}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ThemifyCommon;
